import React from "react";
import { useNavigate } from "react-router-dom";

const JobCard = ({ job }) => {
  const navigate = useNavigate();

  const goToDetails = () => {
    navigate(`/career/${job.id}`);
  };

  return (
    <div
      onClick={goToDetails}
      className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
    >
      <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-3">
        {job.title}
      </h3>

      <p className="text-gray-500 mb-2">
        Experience: {job.experience}
      </p>

      <p className="text-gray-500 mb-4">
        {job.location} • {job.type}
      </p>

      <div className="flex flex-wrap gap-2 mb-4">
        {job.skills.map((skill, index) => (
          <span
            key={index}
            className="px-3 py-1 bg-orange-100 text-orange-600 rounded-full text-sm"
          >
            {skill}
          </span>
        ))}
      </div>

      <p className="text-gray-600 mb-6">
        {job.shortDescription}
      </p>

      <button
        onClick={(e) => {
          e.stopPropagation();
          goToDetails();
        }}
        className="text-orange-500 font-semibold hover:text-orange-600 flex items-center gap-2"
      >
        Show More →
      </button>
    </div>
  );
};

export default JobCard;
